























import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const Root = namespace("root");
@Component({})
export default class skuEditMultiLang extends Vue {
  // @Root.State languageList;
  @Prop() formProp;
  @Prop() rules;
  @Prop() formData;
  @Prop({ default: () => [] }) languageList;
  visibleLang = true;
  toggleLang() {
    this.visibleLang = !this.visibleLang;
  }
}
